// Where the site's sign-up buttons go: the app's sign-in screen (D1), where a
// visitor picks Google or an email and a password, or creates an account
// (UC-0, UC-25). The app sends a new owner on to "Create your restaurant".
//
// The app's origin comes from VITE_APP_BASE and never from a hostname written
// here. vite.site.config.ts refuses to build without it.

export function signUpUrl(appBase: string): string {
	return `${appBase.replace(/\/+$/, '')}/owner`;
}

export const signUpHref = signUpUrl(import.meta.env.VITE_APP_BASE ?? '');
